import {
  CollapsibleContent,
  CollapsibleTrigger,
} from '@synoptic/ui-kit/collapsible/collapsible.js';
import { Collapsible } from '@synoptic/ui-kit/collapsible/collapsible.js';
import { MinusIcon } from '@synoptic/ui-kit/icons/react/minus.js';
import { PlusIcon } from '@synoptic/ui-kit/icons/react/plus.js';
import { inputOptional } from '@synoptic/ui-kit/input/input.css.js';
import clsx from 'clsx';
import { PropsWithChildren, ReactNode } from 'react';
import { useState } from 'react';
import {
  collapsibleLabel,
  collapsibleLabelIcon,
  descriptionVariants,
  titleVariants,
} from './collapsible-label.css';
interface CollapsibleLabelProps {
  className?: string;
  title?: string;
  description?: string;
  /** Preview of the section's current value, shown while collapsed */
  summary?: ReactNode;
  showArrow?: boolean;
  size?: 'sm' | 'sub' | 'md';
  testId?: string;
  /** Start open. Read once: later changes do not reopen or close the section. */
  defaultOpen?: boolean;
}

export const CollapsibleLabel = ({
  children,
  className,
  title,
  description,
  summary,
  showArrow = true,
  size = 'md',
  testId,
  defaultOpen = false,
}: PropsWithChildren<CollapsibleLabelProps>) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Collapsible data-testid={testId} open={open} onOpenChange={setOpen}>
      <CollapsibleTrigger asChild>
        <div className={clsx(collapsibleLabel, className)}>
          {title && <p className={titleVariants[size]}>{title}</p>}
          {description && (
            <p className={clsx(inputOptional, descriptionVariants[size])}>
              ({description})
            </p>
          )}
          {!open && summary}
          {showArrow &&
            (open ? (
              <MinusIcon
                width={20}
                height={20}
                className={collapsibleLabelIcon}
              />
            ) : (
              <PlusIcon
                width={20}
                height={20}
                className={collapsibleLabelIcon}
              />
            ))}
        </div>
      </CollapsibleTrigger>
      <CollapsibleContent>{children}</CollapsibleContent>
    </Collapsible>
  );
};
